import React, { useState, useEffect, useRef, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx";

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseStatement = () => {
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [leaseStatus, setLeaseStatus] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [reasonList, setReasonList] = useState([]);
    const [leaseTypeList, setLeaseTypeList] = useState([]);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        tenantId: "",
        tenantName: "",
        leaseNo: "",
        unitNo: "",
        status: [{ label: "Active", value: "Active" }],
        from: "",
        to: "",
        leaseStart: false,
        leaseType: "",
        company: "",
        category: "",
        leasePM: "Lease",
        reason: "",
        type: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();

        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 5);

        const toDate = new Date(today);
        toDate.setFullYear(today.getFullYear() + 5);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(toDate),
        }));
    }, []);


    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchLeaseNos,LRAgreeSearchCustomers,LRAgreeSearchStatus,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setLeaseList(addAllOption(res?.data?.dropdowns?.LeaseNo));
            setLeaseStatus(addAllOption(res?.data?.dropdowns?.LRAgreeSearchStatus));
            setTanentList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchCustomers));

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("leaseStatementRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseStatementRequest.ToDate", formData?.to || todate);
            params.append("leaseStatementRequest.Property", formData?.property?.value?.value || "All");
            params.append("leaseStatementRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseStatementRequest.Tenant", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseStatementRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("leaseStatementRequest.FD", formData?.source?.label || false);
            params.append("leaseStatementRequest.Company", formData?.company?.label || "All");
            params.append("leaseStatementRequest.Category", formData?.category?.label || "All");
            params.append("leaseStatementRequest.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseStatementRequest.Type", formData?.type?.label || "All");
            params.append("leaseStatementRequest.Reason", formData?.reason?.label || "All");
            params.append("leaseStatementRequest.Status", formData?.status?.label || "Active");
            const res = await apiService.getApiParamater("REPORT_LEASE_STATEMENT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                const data = result?.filter(dat => dat.unitClass === formData?.leasePM)
                setRowData(data || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("leaseStatementRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseStatementRequest.ToDate", formData?.to || todate);
            params.append("leaseStatementRequest.Property", formData?.property?.value?.value || "All");
            params.append("leaseStatementRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseStatementRequest.Tenant", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseStatementRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("leaseStatementRequest.FD", formData?.source?.label || false);
            params.append("leaseStatementRequest.Company", formData?.company?.label || "All");
            params.append("leaseStatementRequest.Category", formData?.category?.label || "All");
            params.append("leaseStatementRequest.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseStatementRequest.Type", formData?.type?.label || "All");
            params.append("leaseStatementRequest.Reason", formData?.reason?.label || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_STATEMENT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                const data = result?.filter(dat => dat.unitClass === formData?.leasePM)
                setExportData(data || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const columnDefs = [
        {
            headerName: "Lease No", field: "lease_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left", pinned: "left", cellRenderer: (params) => {
                return (
                    <span
                        style={{
                            color: "#1a73e8",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontWeight: 500,
                        }}
                        onClick={() => openStatementPopup(params.data)}
                    >
                        {params.value}
                    </span>
                );
            },
        },
        { headerName: "Property", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: "Unit No", field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 100, pinned: "left" },
        { headerName: "Account Code", field: "cust1_No", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
        { headerName: "Account Name", field: "cust1_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 250 },
        { headerName: "Unit Type", field: "unit_Type1", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Unit Category", field: "unit_Category", filter: true, floatingFilter: true, suppressMovable: true, width: 130, },
        { headerName: "Status", field: "status", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Period From", field: "lease_Date", filter: true, floatingfilter: true, suppressMovable: true, width: 120, },
        { headerName: "Period To", field: "lease_Expiry", filter: true, floatingfilter: true, suppressMovable: true, width: 120, },
        // {
        //     headerName: "Rent/Month", field: "actualRent", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
        //     valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        // },
        // {
        //     headerName: "Sec. Deposit", field: "security_Deposit", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
        //     valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        // },

        { headerName: "Lease Term", field: "leaseTermInMonths", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Source", field: "source", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        {
            headerName: "Rent", field: "totalPriceByUser", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Receivable", field: "receivableAsOnDate", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Total Recd(Other)", field: "amountPaid", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Total Recd", field: "amountPaid", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Balance (Other)", field: "amountPaidTilldate", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => {
                const value = Number(params.value || 0);
                return (-value).toFixed(currencyPrecision?.decimalNumbers || 2);
            }
        },
        {
            headerName: "Balance", field: "balanceAsOnDate", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => {

                const value = Number(params.value || 0);
                const received = Number(params?.data?.receivableAsOnDate || 0)
                const balance = Number(params?.data?.amountPaidTilldate || 0)

                return ((received - balance)).toFixed(currencyPrecision?.decimalNumbers || 2);
            }
        },
        { headerName: "Leasing Person", field: "salesPerson", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Agent", field: "agent", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Contact No", field: "mainContactno", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Floor", field: "floor", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Size", field: "totalArea", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        {
            headerName: "Receivable As On Date", field: "receivableAsOnDate", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Amount Paid As On Date", field: "otherAmountPaid", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        {
            headerName: "Balance Paid", field: "balanceAsOnDate", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        },
        // { headerName: "Balance As On Date Type", field: "balanceAsOnDate", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        // { headerName: "Discount / RFA", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        // {
        //     headerName: "PDC Amt (Other)", field: "pdcAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
        //     valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        // },
        // {
        //     headerName: "PDC Amount", field: "pdcAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
        //     valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 2)
        // },
        { headerName: "Booked Expiry", field: "actual_Expiry", filter: true, floatingfilter: true, suppressMovable: true, width: 120, },

    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 5);
        const toDate = new Date(today);
        toDate.setFullYear(today.getFullYear() + 5);
        setFormData({
            property: "",
            tenantId: "",
            tenantName: "",
            leaseNo: "",
            unitNo: "",
            status: "",
            leaseStart: "",
            leaseType: "",
            company: "",
            category: "",
            leasePM: "Lease",
            reason: "",
            type: "",
            from: formatDate(fromDate),
            to: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === "tenantId") {
            setFormData(prev => ({ ...prev, [name]: value, tenantName: { label: value?.value?.text, value: value?.value } }));
        } else if (name === "tenantName") {
            setFormData(prev => ({ ...prev, [name]: value, tenantId: { label: value?.value?.value, value: value?.value } }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const openStatementPopup = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup3",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup3";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.lease_No },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSESTMT" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");
        const columns = [
            { header: "Lease No", dataKey: "lease_No", width: 100 },
            { header: "Property", dataKey: "property_Name", width: 100 },
            { header: "Unit No", dataKey: "unit_No", width: 50 },
            { header: "Account Code", dataKey: "cust1_No", width: 100 },
            { header: "Account Name", dataKey: "cust1_Name", width: 100 },
            { header: "Status", dataKey: "status", width: 50 },
            { header: "Lease Start", dataKey: "lease_Date", width: 60 },
            { header: "Lease Expiry", dataKey: "lease_Expiry", width: 60 },
            { header: "Rent", dataKey: "totalPriceByUser", width: 50 },
            { header: "Balance", dataKey: "balanceAsOnDate", width: 50 },
            { header: "Agent", dataKey: "agent", width: 80 },
            { header: "Contact No", dataKey: "mainContactno", width: 60 },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Lease Statement", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("LeaseStatement.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;
        const columns = [
            { header: "Lease No", dataKey: "lease_No", width: 100 },
            { header: "Property", dataKey: "property_Name", width: 100 },
            { header: "Unit No", dataKey: "unit_No", width: 50 },
            { header: "Account Code", dataKey: "cust1_No", width: 100 },
            { header: "Account Name", dataKey: "cust1_Name", width: 100 },
            { header: "Status", dataKey: "status", width: 50 },
            { header: "Lease Start", dataKey: "lease_Date", width: 60 },
            { header: "Lease Expiry", dataKey: "lease_Expiry", width: 60 },
            { header: "Rent", dataKey: "totalPriceByUser", width: 50 },
            { header: "Balance", dataKey: "balanceAsOnDate", width: 50 },
            { header: "Agent", dataKey: "agent", width: 80 },
            { header: "Contact No", dataKey: "mainContactno", width: 60 },
        ];

        const excelData = exportData.map(item => {
            const row = {};
            columns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Lease Statement");
        XLSX.writeFile(workbook, "Lease_Statementt.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant ID</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantId}
                                    loadOptions={loadOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantId", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantName}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantName", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Status</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.status}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                                    options={leaseStatus?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <div className="d-flex">
                                    <label className="form-label w-0">To</label>
                                    <DatePicker
                                        selected={formData.to}
                                        onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="followtoCheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.leaseStart}
                                        onChange={(e) => setFormData(prev => ({ ...prev, leaseStart: e.target.checked }))}
                                    />
                                    <label className="form-check-label">Lease Start Date</label>
                                </div>
                            </div>
                            <div className="d-flex mt-2 gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Lease Statement List</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    onCellClicked={(params) => {
                                        if (params.colDef.field === "lease_No") {
                                            openStatementPopup(params.data);
                                        }
                                    }}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default LeaseStatement;